export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.logout.success': 'Successfully Logged Out!',
  // Login Page!
  'error.userNotFound': 'Incorrect Email or password!',
  'pages.registration.success': 'Registration Successful.',
  'pages.login.twofactor': 'Second Factor Authentication',
  'pages.login.twofactor.required': 'Please enter the 6 digit code from your authenticator app.',
  'pages.login.twofactor.label': 'Code',
  'pages.login.resend.confirmation': 'Resend Confirmation Email',
  'pages.login.verification.success': 'Verification Link Sent to your Email!',
  'pages.login.verification.error': 'You haven`t verified your email yet!',
  'pages.login.verification.resend': 'Do you want to resend the email confirmation link?',
  'pages.login.verification.resend.cancel': 'Cancel',
  'pages.login.form.email.validation.required': 'Email is required',
  'pages.login.form.email.validation.email': 'Email address is not valid!',
  'pages.login.form.email.placeholder': 'Email',
  'pages.login.form.password.placeholder': 'Password',
  'pages.login.verification.resend.button.time': 'Resend ({countdown}s)',
  'pages.login.verification.resend.button': 'Resend',
  // Profile Page
  'profile.changePassword.success': 'Password Changed Successfully!',
  'profile.changePassword.field.old.label': 'Old Password',
  'profile.changePassword.field.old.required': 'Enter your old password',
  'profile.changePassword.field.new.label': 'New Password',
  'profile.changePassword.field.new.required': 'Enter your new password',
  'profile.changePassword.field.new.min': 'Password must be at least 8 characters long',
  'profile.changePassword.field.new.minUpperCase':
    'Password must contain at least one uppercase letter',
  'profile.changePassword.field.new.minLowerCase':
    'Password must contain at least one lowercase letter',
  'profile.changePassword.field.new.minNumber': 'Password must contain at least one number',
  'profile.changePassword.field.confirm.label': 'Confirm Password',
  'profile.changePassword.field.confirm.required': 'Please repeat new password again!',
  'profile.changePassword.button': 'Change Password',

  // User Profile Page
  'userProfile.userInfo.title': 'User Info',
  'userProfile.userInfo.fullName': 'Full Name',
  'userProfile.userInfo.email': 'Email',
  'userProfile.userInfo.phone': 'Phone',
  'userProfile.userInfo.twofa.status.enabled': 'Enabled',
  'userProfile.userInfo.twofa.setup': 'Setup',

  // Dashboard Page
  'dashboard.walletBalance': 'Wallet Balance',
  'dashboard.hotWalletBalance': 'Hot Wallet Balance',
  'dashboard.feeBalance': 'Fee Balance',
  'dashboard.message.walletFetch.error': 'Failed to fetch wallet data',
  'dashboard.analytics.title': 'Fee Analytics',
  'dashboard.analytics.period.week': '7 Days',
  'dashboard.analytics.period.month': '31 Days',
  'dashboard.analytics.totalFee': 'Total Fees',
  'dashboard.analytics.daily.title': 'Daily Fees',
  'dashboard.analytics.daily.feeTotal': 'Fee Total',
  'dashboard.analytics.daily.txCount': 'Transactions',
  'dashboard.todayFee': 'Total Fee',
  'dashboard.dataNotAvailable': 'Data not available',
  'dashboard.section.currentBalances': 'Current Balances',
  'dashboard.section.analytics': 'Analytics',
  'dashboard.chart.tooltip.feeTotal': 'Fee Total',

  // Hot Wallet page
  'hotWallet.table.column.lowBalanceNotificationAmount': 'USDT Low Balance Notification Amount',
  'hotWallet.modal.lowBalance.title':
    'Set Low Balance Notification AmountUSDT Low Balance Notification Amount',
  'hotWallet.modal.lowBalance.input': 'Enter amount',
  'hotWallet.modal.minTrigger.title': 'Minimum Trigger Amount',
  'hotWallet.modal.minTrigger.input': 'Enter amount',
  'hotWallet.page.fetch.error': 'Failed to fetch Hot Wallets',
  'hotWallet.page.minAmount.success': 'Minimum Notification Amount updated successfully!',
  'hotWallet.page.minAmount.error': 'Failed to update minimum notification amount!',
  'hotWallet.page.consolidate.success': 'Funds consolidated initiated',
  'hotWallet.page.consolidate.validation': 'Please enter an amount',
  'hotWallet.page.table.column.address': 'Wallet Address',
  'hotWallet.page.table.column.balance': 'Native Balance',
  'hotWallet.page.table.column.network': 'Network',
  'hotWallet.page.table.column.usdtBalance': 'USDT Balance',
  'hotWallet.page.table.column.action': 'Action',
  'hotWallet.page.table.action.collectFee': 'Collect Fee',
  'hotWallet.page.table.action.collectFund': 'Collect Fund',
  'hotWallet.page.table.action.freeze': 'Freeze',
  'hotWallet.page.table.action.unfreeze': 'Unfreeze',
  'hotWallet.page.table.action.transfer': 'Transfer',
  'hotWallet.page.transfer.success': 'Transfer initiated, please check withdraw logs for status',
  'hotWallet.modal.transfer.label.address': 'Receiving Address',
  'hotWallet.modal.transfer.placeholder.address': 'Please enter receiving address',
  'hotWallet.modal.transfer.label.amount': 'Transfer Amount',
  'hotWallet.modal.transfer.placeholder.amount': 'Please enter transfer amount',
  'hotWallet.modal.transfer.label.twoFA': '2FA Code',
  'hotWallet.modal.transfer.placeholder.twoFA': 'Please enter 2FA code',
  'hotWallet.modal.transfer.title': 'Transfer',
  'hotWallet.modal.transfer.hint.twoFA': 'If not set, please set it in profile page',
  'hotWallet.modal.transfer.error': 'Failed to transfer, please contact support',

  // Sub Users Page
  'subUsers.title': 'Sub Users',
  'subUsers.table.column.fullName': 'Full Name',
  'subUsers.table.column.email': 'Email',
  'subUsers.table.column.role': 'Role',
  'subUsers.table.column.action': 'Action',
  'subUsers.table.column.permissions': 'Permissions',
  'subUsers.action.delete.success': 'Sub User deleted successfully',
  'subUsers.action.delete.confirm': 'Are you sure you want to delete this Sub User?',
  'subUsers.action.delete.confirm.cancel': 'No',
  'subUsers.action.delete.confirm.ok': 'Yes',
  'subUsers.action.delete.error': 'Failed to delete Sub User',
  'subUsers.action.fetch.error': 'Failed to fetch Sub Users',

  // Consolidate Logs Page
  'consolidateLogs.status.pending': 'Pending',
  'consolidateLogs.status.success': 'Success',
  'consolidateLogs.status.fail': 'Failed',
  'consolidateLogs.status.rejected': 'Rejected',
  'consolidateLogs.table.column.date': 'Date',
  'consolidateLogs.table.column.txHash': 'TX Hash',
  'consolidateLogs.table.column.fromAddress': 'From Address',
  'consolidateLogs.table.column.toAddress': 'To Address',
  'consolidateLogs.table.column.amount': 'Amount',
  'consolidateLogs.table.column.batchId': 'Batch ID',
  'consolidateLogs.table.column.status': 'Status',
  'consolidateLogs.filters.column.all': 'All',
  'consolidateLogs.search.placeholder': 'Search for consolidation logs',

  // Transactions Page
  'transactions.table.title': 'Recent Transactions',
  'transactions.table.tx': 'Tx',
  'transactions.table.id': 'Id',
  'transactions.table.from': 'From',
  'transactions.table.to': 'To',
  'transactions.table.network': 'Network',
  'transactions.table.inOut': 'In | Out',
  'transactions.table.amount': 'Amount',
  'transactions.table.amountAfterFee': 'Amount After Fee',
  'transactions.table.feeAmount': 'Fee Amount',
  'transactions.table.timestamp': 'Timestamp',
  'transactions.table.transferDirection.in': 'IN',
  'transactions.table.transferDirection.out': 'OUT',
  'transactions.table.transferDirection.all': 'ALL',
  'transactions.table.transferDirection.placeholder': 'Transfer Direction',
  'transactions.table.export': 'Export',
  'transactions.table.failedToFetch': 'Failed to fetch transactions',
  'transactions.table.invalidDate': 'Invalid Date',
  'transactions.table.notAvailable': 'N/A',
  'transactions.table.fromLabel': 'From:',
  'transactions.table.toLabel': 'To:',

  // Transaction Search
  'transactions.search.column.txHash': 'Tx Hash',
  'transactions.search.column.from': 'From Address',
  'transactions.search.column.to': 'To Address',
  'transactions.search.column.id': 'Tx ID',
  'transactions.search.placeholder.general': 'Search all fields...',
  'transactions.search.placeholder.txHash': 'Search transaction hash...',
  'transactions.search.placeholder.from': 'Search from address...',
  'transactions.search.placeholder.to': 'Search to address...',
  'transactions.search.placeholder.id': 'Search transaction ID...',
  'transactions.search.clear': 'Clear search',
  'transactions.search.noResults': 'No transactions found matching your search criteria',
  'transactions.search.loading': 'Searching transactions...',
  'transactions.search.error': 'Search failed. Please try again.',

  // Wallets Page
  'wallets.table.column.address': 'Wallet Address',
  'wallets.table.column.name': 'Name',
  'wallets.table.column.network': 'Network',
  'wallets.table.column.usdtBalance': 'USDT Balance',
  'wallets.table.column.balanceAfterFee': 'USDT Balance After Fee',
  'wallets.table.column.accumFees': 'USDT Accumulative Fees',
  'wallets.table.column.reference': 'Reference',
  'wallets.table.search.placeholder': 'Search by wallet',

  // Withdraw Logs Page
  'withdrawLogs.status.pending': 'Pending',
  'withdrawLogs.status.success': 'Success',
  'withdrawLogs.status.fail': 'Failed',
  'withdrawLogs.table.column.date': 'Date',
  'withdrawLogs.table.column.txHash': 'TX Hash',
  'withdrawLogs.table.column.fromAddress': 'From Address',
  'withdrawLogs.table.column.toAddress': 'To Address',
  'withdrawLogs.table.column.network': 'Network',
  'withdrawLogs.table.column.token': 'Token',
  'withdrawLogs.table.column.amount': 'Amount',
  'withdrawLogs.table.column.reference': 'Reference',
  'withdrawLogs.table.column.status': 'Status',
  'withdrawLogs.table.column.actionType': 'Action Type',
  'withdrawLogs.table.column.value.actionType.MANUAL': 'Manual',
  'withdrawLogs.table.column.value.actionType.API': 'Api',

  // Withdraw Logs Search
  'withdrawLogs.search.placeholder.txHash': 'Search tx hash...',
  'withdrawLogs.search.placeholder.from': 'Search from address...',
  'withdrawLogs.search.placeholder.to': 'Search to address...',
  'withdrawLogs.search.clear': 'Clear search',

  // Withdraw Logs Filters
  'withdrawLogs.filter.status': 'Status',
  'withdrawLogs.filter.network': 'Network',
  'withdrawLogs.filter.token': 'Token',
  'withdrawLogs.filter.actionType': 'Action Type',

  // Withdraw Logs Export
  'withdrawLogs.export.limit.note':
    'Export is limited to a maximum of 3 months. Please narrow your date range.',
  'withdrawLogs.export.no_data': 'No data to export for current filters.',
  'withdrawLogs.export.max_records': 'No filters applied: up to 10,000 records will be exported.',
  'withdrawLogs.export.limit.short': 'Max 3 months range for export',

  // Withdraw Requests Page
  'withdrawRequests.page.table.column.automated': 'Automated',
};
